/**
 * One beauty item, the same row in both modes (merged page, GĐ2): name (+ "Đổi hình dạng" for a face-shape item),
 * strength in %, a colour when the item has one, a note under it. "Ảnh thẻ" adds an on/off box (everything off by
 * default, the strength kept while off); in "Ảnh chuyên nghiệp" 0 % is off. A drag is one undo step (`onCommit`).
 */
import { useId } from "react";

interface Props {
  label: string;
  value: number;
  min?: number;
  max?: number;
  step?: number;
  onChange: (value: number, transient: boolean) => void;
  onCommit?: () => void;
  /** with an on/off box ("Ảnh thẻ"): the box is named by `label`, the slider by `sliderLabel` */
  on?: boolean;
  onToggle?: (on: boolean) => void;
  sliderLabel?: string;
  badge?: string;
  note?: string;
  colour?: { value: string; label: string; onPick: (hex: string) => void };
  /** double click on the row: back to this value */
  resetTo?: number;
  title?: string;
}

export function BeautyRow({ label, value, min = 0, max = 1, step = 0.05, onChange, onCommit, on, onToggle, sliderLabel,
                            badge, note, colour, resetTo, title }: Props) {
  const sliderId = useId();
  const boxId = useId();
  const toggle = onToggle !== undefined;
  const pct = `${Math.round(value * 100)} %`;
  const isOn = toggle ? Boolean(on) : value > 0;
  const commit = () => onCommit?.();
  return (
    <div className={`beauty-row retouch-row${isOn ? " is-on" : ""}`} title={title}
         onDoubleClick={resetTo === undefined ? undefined : () => onChange(resetTo, false)}>
      <span className="beauty-name">
        {toggle ? (
          <span className="check">
            <input id={boxId} type="checkbox" checked={isOn} onChange={(e) => onToggle?.(e.target.checked)} />
            <label htmlFor={boxId}>{label}</label>
          </span>
        ) : <label htmlFor={sliderId}>{label}</label>}
        {badge && <span className="shape-badge">{badge}</span>}
      </span>
      <input id={sliderId} type="range" min={min} max={max} step={step} value={value} disabled={toggle && !isOn}
             aria-label={toggle ? sliderLabel : undefined} aria-valuetext={pct}
             onChange={(e) => onChange(Number(e.target.value), true)}
             onPointerUp={commit} onKeyUp={commit} onBlur={commit} onTouchEnd={commit} />
      <output htmlFor={sliderId}>{pct}</output>
      {colour ? (
        <label className="beauty-colour" title="Chọn màu">
          <input type="color" value={colour.value} aria-label={colour.label} onChange={(e) => colour.onPick(e.target.value)} />
        </label>
      ) : <span aria-hidden="true" />}
      {note && <small className="hint beauty-note">{note}</small>}
    </div>
  );
}
